import store from '../../config/store'

const LocalStorage = {

  methods: {

    saveData() {
      window.localStorage.setItem(store.localStorageKey, JSON.stringify(store.data))
    }
  }

};
export default LocalStorage
